import React, { Fragment, useEffect, useState } from 'react';
type CountdownProps = {
  className?: string;
};
export function Countdown({
  className = ''
}: CountdownProps) {
  const [seconds, setSeconds] = useState(83027);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: Array<[string, number]> = [['hrs', Math.floor(seconds / 3600)], ['min', Math.floor(seconds % 3600 / 60)], ['sec', seconds % 60]];
  return <div className={`inline-flex items-center gap-2 ${className}`} aria-label="Time remaining on this offer" data-id="element-266" data-mp="1ji3jpgma3sjo">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-267" data-mp="1te6qizs2sfcy" data-mpi={index}>
          {index > 0 && <span className="text-2xl font-black text-silver-200" data-id="element-268" data-mp="1tgja1hdhexs4">:</span>}
          <span className="metal flex min-w-[64px] flex-col items-center rounded-lg border border-silver-300 px-3 py-2 leading-none shadow-md shadow-black/30" data-id="element-269" data-mp="38tm33rj4dogp">
            <b className="text-2xl font-extrabold tabular-nums text-navy-950" data-id="element-270" data-mp="2c86p4t28r8yo">
              {String(value).padStart(2, '0')}
            </b>
            <small className="mt-1 text-[10px] font-bold uppercase tracking-wider text-navy-800" data-id="element-271" data-mp="2h56xjamkcnsy">{label}</small>
          </span>
        </Fragment>)}
    </div>;
}